export default __webpack_public_path__ + "static/media/calendar.d4750d3b.svg";